/**
 * The login panel's buttons, matching the app: brand purple primary (the theme's `primary` is
 * pink), and white / outlined provider buttons like the app's SocialAuthButtons.
 */
export const LOGIN_PRIMARY_BUTTON =
  'w-full rounded-full bg-[var(--brand-primary)] text-white hover:bg-[var(--brand-primary)]/90';
export const LOGIN_GOOGLE_BUTTON =
  'flex h-11 w-full items-center justify-center gap-2 rounded-full bg-white text-sm font-semibold text-black transition-colors hover:bg-gray-100 disabled:opacity-60';
export const LOGIN_OUTLINE_BUTTON =
  'flex h-11 w-full items-center justify-center gap-2 rounded-full border border-white/20 bg-white/5 text-sm font-semibold text-white transition-colors hover:bg-white/10 disabled:opacity-60';
/** The small dev / QA-only links under the buttons. */
export const LOGIN_DEV_LINK =
  'rounded px-2 py-1 text-muted-foreground underline-offset-4 transition-colors hover:text-white hover:underline';
